import { sprintf } from 'sprintf-js';
import moment from 'moment';
import isNull from 'lodash/isNull';

import Logger from './logger';
import translation from '../../config/translation';

const log = new Logger({
	name: 'translation-error',
	message: 'Check word in translation file. Word: %s, language: %s, location: %s'
});

export default state =>  {
	const language  = (
		state.app.userData &&
		state.app.userData.general &&
		state.app.userData.general.language
	);
	const intl = (word, ...params) => {
		if (!word) {
			return word;
		}
		if (isNull(translation[word])) {
			return sprintf(word, ...params);
		}
		let newWord = word;
		if (!translation[word] || !translation[word][language]) {
			log.add(word, language, window.location.href);
		} else {
			newWord = translation[word][language];
		}
		return sprintf(newWord, ...params);
	};
	intl.language = language;
	moment.locale(language);

	return intl;
};



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/shared/intl.js